export default __webpack_public_path__ + "static/media/kimchilingua_home.400342ac.jpg";